<template>
  <div class="scoredetail">
    <el-form style="border-bottom: 1px dashed #d0d0d0">
      <el-form-item style="width: 400px">
        <div class="itemtitle"><span>*</span>课程</div>
        <el-input v-model="examDetail.relName" disabled style="width:280px"></el-input>
      </el-form-item>

      <el-form-item style="width: 600px">
        <div class="itemtitle"><span>*</span>考试标题</div>
        <el-input v-model="examDetail.examTitle" disabled style="width:480px"></el-input>
      </el-form-item>

      <el-form-item style="width: 400px">
        <el-row>
          <div class="itemtitle"><span>*</span>试卷配置</div>
        </el-row>
        <el-row style="margin:10px 30px 0;">
          <el-col :span="5"><div class="itemtitle"><span>*</span>单选题：</div></el-col>
          <el-col :span="4" style="margin: 0 5px"><el-input v-model="examDetail.examRadioNum" disabled></el-input></el-col>
          <el-col :span="1">题</el-col>
          <el-col :span="2" :offset="2">每题</el-col>
          <el-col :span="4" style="margin: 0 5px"><el-input v-model="examDetail.examRadioScore" disabled></el-input></el-col>
          <el-col :span="1">分</el-col>
        </el-row>
        <el-row style="margin:10px 30px 0;">
          <el-col :span="5"><div class="itemtitle"><span>*</span>多选题：</div></el-col>
          <el-col :span="4" style="margin: 0 5px"><el-input v-model="examDetail.examMultipleNum" disabled></el-input></el-col>
          <el-col :span="1">题</el-col>
          <el-col :span="2" :offset="2">每题</el-col>
          <el-col :span="4" style="margin: 0 5px"><el-input v-model="examDetail.examMultipleScore" disabled></el-input></el-col>
          <el-col :span="1">分</el-col>
        </el-row>
        <el-row style="margin:10px 30px 0;">
          <el-col :span="5"><div class="itemtitle"><span>*</span>问答题：</div></el-col>
          <el-col :span="4" style="margin: 0 5px"><el-input v-model="examDetail.examQuestionNum" disabled></el-input></el-col>
          <el-col :span="1">题</el-col>
          <el-col :span="2" :offset="2">每题</el-col>
          <el-col :span="4" style="margin: 0 5px"><el-input v-model="examDetail.examQuestionScore" disabled></el-input></el-col>
          <el-col :span="1">分</el-col>
        </el-row>
        <el-row style="margin:10px 30px 0;">
          <el-col :span="5"><div class="itemtitle"><span>*</span>总分：</div></el-col>
          <el-col :span="12" style="margin: 0 5px"><el-input v-model="TotalScore" disabled class="total"></el-input></el-col>
        </el-row>
      </el-form-item>
    </el-form>

    <el-form style="border-bottom: 1px dashed #d0d0d0">
      <el-form-item>
        <p style="text-align: center;font-size: 26px;padding:30px 30px 0">2022年新生心理知识普及培训</p>
      </el-form-item>
      <el-form-item style="margin:0;" v-if="RadioDataList.length>0">
        <el-row>
          <h1>单选题</h1>
        </el-row>
      </el-form-item>
      <el-form-item v-for="(item,i) in RadioDataList">
        <el-row style="padding:0 20px;"><label>{{i+1}}、</label>{{item.questionTitle}}</el-row>
        <el-row style="padding:0 40px;line-height: 28px;">
          <el-col v-for="items in item.answers">{{ items.option }}</el-col>
        </el-row>
        <el-row style="width: 300px;padding-left: 40px">
          <el-col :span="10"><el-input v-model="item.userAnswer" disabled></el-input></el-col>
          <el-col :span="12" :offset="2">正确答案：{{ item.rightAnswer }}</el-col>
          <el-col :span="6">得分：{{item.userQuestionScore}}分</el-col>
        </el-row>
      </el-form-item>

      <el-form-item style="margin:0;" v-if="MultipleDataList.length>0">
        <el-row>
          <h1>多选题</h1>
        </el-row>
      </el-form-item>
      <el-form-item v-for="(item,i) in MultipleDataList">
        <el-row style="padding:0 20px;"><label>{{i+1}}、</label>{{item.questionTitle}}</el-row>
        <el-row style="padding:0 40px;line-height: 28px;">
          <el-col v-for="(items,index) in item.answers"><label>{{index+1}}、</label>{{ items.option }}</el-col>
        </el-row>
        <el-row style="width: 300px;padding-left: 40px">
          <el-col :span="8"><el-input v-model="item.userAnswer" disabled></el-input></el-col>
          <el-col :span="12" :offset="2">正确答案：{{ item.rightAnswer }}</el-col>
          <el-col :span="6">得分：{{item.userQuestionScore}}分</el-col>
        </el-row>
      </el-form-item>

      <el-form-item style="margin:0;" v-if="QuestionList.length>0">
        <el-row>
          <h1>问答题</h1>
        </el-row>
      </el-form-item>
      <el-form-item v-for="(item,i) of QuestionList">
        <el-row style="padding:0 20px;"><label>{{i+1}}、</label>{{ item.questionTitle}}</el-row>
        <el-row style="padding:0 40px;line-height: 28px;">
          <el-input type="textarea" v-model="item.userAnswer" disabled></el-input>
        </el-row>
        <el-row style="width: 300px;padding-left: 40px">
          <el-col :span="6">得分：{{item.userQuestionScore}}分</el-col>
        </el-row>
      </el-form-item>
    </el-form>

    <p style="padding:30px 20px 0;font-size:16px;font-weight: bold;">总得分：{{examDetail.examScore}}分</p>
    <el-button style="margin:10px auto;display: block;" @click="$router.go(-1)">返回</el-button>
  </div>
</template>

<script>
export default ({
  name:'scoredetail',
  data(){
    return{
      examDetail:'',
      TotalScore:'',
      RadioDataList:[],
      MultipleDataList:[],
      QuestionList:[]
    }
  },
  created() {
    this.getUserExamDetail();
  },
  methods:{
    getUserExamDetail(){
      this.$Http_Post('edu/examRecord/getUserExamDetail',{examRecordId:this.$route.query.examRecordId}).then(res=>{
        if(res.Code==0){
          this.examDetail=res.Data;
          this.TotalScore=res.Data.examMultipleNum*res.Data.examMultipleScore+res.Data.examQuestionNum*res.Data.examQuestionScore+res.Data.examRadioNum*res.Data.examRadioScore;
          this.topic();
        }else{
          this.$message({type: 'error', message:res.Message});
        }
      });
    },

    // 题目集合
    topic(){
      for(let item of this.examDetail.questionInfos){
        if(item.questionType==1){
          this.RadioDataList.push(item);
        }else if(item.questionType==2){
          this.MultipleDataList.push(item);
        }else{
          this.QuestionList.push(item);
        }
      }
    }
  },
})
</script>

<style scoped>
.scoredetail{background: #fff;padding:30px;}
.scoredetail .itemtitle{display: inline-block;margin-right: 10px;width:80px;text-align: right}
.scoredetail .itemtitle span{color: red;}
</style>